import SingleSelect from '../../../../shared/components/SingleSelect';
import { useServerList } from '../../../../hooks/useServerList';
import { useSelectedServer } from '../../../../hooks/useSelectedServer';

const ServerSelectContainer = () => {
  const [{ servers, isLoading }] = useServerList();
  const [selectedServer, setSelectedServer] = useSelectedServer();

  return (
    <SingleSelect
      label='Select server'
      options={servers}
      selectOptionId={server => server.displayName}
      selectOptionLabel={server => server.displayName}
      defaultOptionId={selectedServer?.displayName}
      isLoading={isLoading}
      onSelect={setSelectedServer}
    />
  );
};

export default ServerSelectContainer;
